<div class="vendor-engine">

  <!-- TOP NAV -->
  <!-- <nav class="vendor-nav">
    <div class="container nav-inner">
      <div class="brand">
        <div class="logo">V</div>
        <div>
          <h1>VendorEngine<span>.AI</span></h1>
          <p>On-Demand Vendor Intelligence</p>
        </div>
      </div>

      <button class="primary-btn" (click)="handleRunEngine()" [disabled]="pipelineStep === 'loading'">
        SEARCH & RECOMMEND
      </button>
    </div>
  </nav> -->

  <main class="container main-grid">

    <!-- LEFT PANEL -->
    <section class="left-panel">
      <h2 class="section-title">Project Hiring Summary</h2>

      <div class="card form-card">
        <div class="two-col">
          <div>
            <label>Category</label>
            <input [(ngModel)]="form.main_service" />
          </div>

          <div>
            <label>Sub-Category</label>
            <input [(ngModel)]="form.sub_service" />
          </div>
        </div>

        <div>
          <label>Capabilities / Skills</label>
          <input [value]="form.skills.join(', ')" (input)="onSkillsInput($event)" />
        </div>

        <div>
          <label>Experience Band</label>
          <select [(ngModel)]="form.experience_band">
            <option value="">Select experience band</option>

            <option value="Junior (1–3 yrs)">Junior (1–3 yrs)</option>

            <option value="Mid to Senior (3+ yrs preferred)">
              Mid to Senior (3+ yrs preferred)
            </option>

            <option value="Senior (8+ yrs)">Senior (8+ yrs)</option>
          </select>
        </div>

        <div>
          <label>Preferred Location</label>
          <input [(ngModel)]="form.location" placeholder="e.g. India, Mumbai, Remote" />
        </div>


        <button class="primary-btn" (click)="handleRunEngine()" [disabled]="pipelineStep === 'loading'">
          SEARCH & RECOMMEND
        </button>
      </div>


    </section>

    <!-- RIGHT PANEL -->
    <section class="right-panel">

      <h2 class="section-title pulse">
        <span class="dot active"></span>
        Synthesis Result
      </h2>

      <!-- EMPTY STATE -->
      <div *ngIf="!result && pipelineStep === 'idle'" class="empty-state">
        <div class="icon-box">🔍</div>
        <h3>Direct Vendor Search</h3>
        <p>
          Configure your hiring brief. We perform a live query against the
          contributor pool and synthesize suitability signals.
        </p>

        <button class="primary-btn large" (click)="handleRunEngine()">
          START DIRECT SEARCH
        </button>
      </div>

      <!-- LOADING -->
      <div *ngIf="pipelineStep === 'loading'" class="empty-state">
        ⏳ Analyzing vendors…
      </div>

      <!-- RESULTS -->
      <ng-container *ngIf="result">

        <!-- ====== RECOMMENDED VENDORS ====== -->
        <div *ngFor="let v of result.recommendations" class="card vendor-card">

          <!-- HEADER -->
          <div class="vendor-header">
            <span>
            <h2>{{ v.contributor_name || 'Unknown' }}</h2>
            <span class="confidence-pill" [class.high]="v.end_to_end_confidence === 'High'"
              [class.medium]="v.end_to_end_confidence === 'Medium'" [class.low]="v.end_to_end_confidence === 'Low'">
              CONFIDENCE: {{ v.end_to_end_confidence | uppercase }}
            </span>
            </span>
            <button class="vendor-portfolio-btn" (click)="openPortfolio(v.portfolio_link)">
               <i class="bi bi-link-45deg"></i> Portfolio
             </button>
          </div>

          <!-- REASONING -->
          <ul class="reasoning-list">
            <li *ngFor="let r of v.reasoning">{{ r }}</li>
          </ul>

          <hr />

          <!-- CAPABILITIES + DELIVERY -->
          <div class="two-col">
            <div>
              <p class="subheading">CORE CAPABILITY MATCH</p>
              <div class="pill-group">
                <span class="pill" *ngFor="let s of v.matched_skills">
                  {{ s }}
                </span>
              </div>
            </div>

            <div>
              <p class="subheading">DELIVERY COVERAGE</p>
              <div class="pill-group dark">
                <span class="pill dark" *ngFor="let d of v.deliverables_covered">
                  {{ d }}
                </span>
              </div>
            </div>
          </div>

          <!-- RISK -->
          <div *ngIf="v.risk_notes" class="risk-box">
            <strong>RISK ADVISORY:</strong>
            {{ v.risk_notes }}
          </div>
        </div>

        <!-- ====== DISQUALIFICATIONS + STRATEGY ====== -->
        <div class="two-col disqualify-grid">

          <!-- AI DISQUALIFICATIONS -->
          <div class="card">
            <h3 class="danger-title">AI Disqualifications</h3>

            <div *ngFor="let ex of result.exclusions" class="exclusion-block">
              <p class="exclusion-reason">{{ ex.reason }}</p>

              <div class="pill-group">
                <span class="pill muted" *ngFor="let name of ex.vendor_names">
                  {{ name }}
                </span>
              </div>
            </div>
          </div>

          <!-- STRATEGIC LOGIC -->
          <div class="card dark-card">
            <h3>Strategy: Risky</h3>
            <p>
              {{ result.final_logic.expectation_risks }}
            </p>
          </div>

        </div>
      </ng-container>

    </section>
  </main>
</div>